import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './tile.module.css';

class Tile extends Component {
  constructor (props) {
    super(props);
    this.tile = React.createRef();
  }

  render () {
    const { children, ...rest } = this.props;

    return (
      // We choose to disable these errors because this onClick handler has the same functionality as the onChange handler
      // which is attached to the input
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div
        className={styles.Tile}
        ref={this.tile}
      >
        {children({ ...rest })}
      </div>
    );
  }
}

Tile.propTypes = {
  value: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
};

export default Tile;
